﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as FileApi from 'fileapi';

import tpl_customSchemaDataImport from './tpl/customSchemaDataImport.html';
import language from '../../../common/language';
import * as Entities_CustomSchemaData from '../../entities/customSchemaData';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../lib/entities/empty';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_customSchemaDataImport();
    },
    initialize: function () {
        this.app = this.options.app;
        this.settingModel = this.options.settingModel;

        this.listenTo(this.app.entities.collections.customSchemaSchema, 'customSchemaSchema_add', this.render);
        this.listenTo(this.app.entities.collections.customSchemaSchema, 'customSchemaSchema_remove', this.render);

        var self = this;
        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel,'customSchemaDataImport:setSchemaModel', function(schemaModel) {
            self.options.schemaModel = schemaModel;
        });
    },
    ui : {
        'customSchemaDataImport_btnImportSubmit' : '#customSchemaDataImport_btnImportSubmit',
        'customSchemaDataImport_labelImport' : '#customSchemaDataImport_labelImport',
        'customSchemaDataImport_selectSchema' : '#customSchemaDataImport_selectSchema',
        'customSchemaDataImport_input_ShowSchema' : '#customSchemaDataImport_input_ShowSchema',
        'customSchemaDataImport_input_ShowSchemaBigscreen' : '#customSchemaDataImport_input_ShowSchemaBigscreen'
    },
    events: {
        'change @ui.customSchemaDataImport_btnImportSubmit': 'btnImportSubmit',
        'change @ui.customSchemaDataImport_selectSchema': 'selectSchemaChange'
    },
    onRender: function () {
        var self = this;

        //FileAPI.event.on(this.ui.customSchemaDataImport_btnImportSubmit[0], 'change', function (event){
        //    self.btnImportSubmit(event);
        //});
        
        //this.$el.find('.file-input-wrapper').removeClass('btn-default');
        this.setup();

        return this;
    },
    setup: function () {
        if (this.settingModel.attributes.EventId > 0 && this.settingModel.attributes.SchemaSchemaId > 0) {
            this.ui.customSchemaDataImport_labelImport.prop('disabled', false);
        }
        else {
            this.ui.customSchemaDataImport_labelImport.prop('disabled', true);
        }
    },
    btnImportSubmit: function (event) {
        event.preventDefault();

        if (this.settingModel.attributes.EventId > 0 && this.settingModel.attributes.SchemaSchemaId > 0) {

            var self = this;
            var file = FileAPI.getFiles(event)[0];
            var array = [];

            var dialogWaitingModel = new Entities_Empty.Model();
            dialogWaitingModel.attributes.Title = resources.X100250;
            dialogWaitingModel.attributes.Text = resources.X100251;
            dialogWaitingModel.attributes.Button = resources.X100279;

            var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
            var callback = function (options) {
                this.stopListening(dialogWaiting, "dialog:okclicked", callback);
            }
            this.listenTo(dialogWaiting, "dialog:okclicked", callback);

            var showSchema;
            var showSchemaBigscreen;

            this.ui.customSchemaDataImport_input_ShowSchema.is(':checked') ? showSchema = true : showSchema = false;
            this.ui.customSchemaDataImport_input_ShowSchemaBigscreen.is(':checked') ? showSchemaBigscreen = true : showSchemaBigscreen = false;

            dialogWaiting.onShow =  function(){
                setTimeout(function(){
                FileAPI.readAsBinaryString(file, function (param) {
                    if (param.type == 'load') {
                    

                        app.progress_count++;
         
                        var record_num = self.options.schemaModel.attributes.FieldUsed;  // or however many elements there are in each row
                        var allTextLines = param.result.split(/\r\n|\n/);
                        var entries = allTextLines[0].split(';');
                        var lines = [];

                        //var table_firstVisibleItem = app.views.customSchemaDataList.table_getFirstVisibleItem();
                        //var jumpFirst = table_firstVisibleItem;
                        self.triggerMethod('table_getFirstVisibleItem');
                        var table_firstVisibleItem = self.settingModel.attributes.TableFirstVisibleItem;
                        var jumpFirst = table_firstVisibleItem;

                        for (var j = 0; j < allTextLines.length; j++) {
                            var entries = allTextLines[j].split(';');

                            var tmpModel = new Entities_CustomSchemaData.Model();
                            tmpModel.attributes.id = table_firstVisibleItem;
                            tmpModel.attributes.orgid = -1;
                            tmpModel.attributes.EventId = self.settingModel.attributes.EventId;

                            tmpModel.attributes.Schema = self.settingModel.attributes.SchemaSchemaId;
                            tmpModel.attributes.Field01 = '';
                            tmpModel.attributes.Field02 = '';
                            tmpModel.attributes.Field03 = '';
                            tmpModel.attributes.Field04 = '';
                            tmpModel.attributes.Field05 = '';
                            tmpModel.attributes.Field06 = '';
                            tmpModel.attributes.Field07 = '';
                            tmpModel.attributes.Field08 = '';
                            tmpModel.attributes.Field09 = '';
                            tmpModel.attributes.Field10 = '';
                            tmpModel.attributes.Field11 = '';
                            tmpModel.attributes.Field12 = '';

                            tmpModel.attributes.ShowSchema = showSchema;
                            tmpModel.attributes.ShowSchemaBigscreen = showSchemaBigscreen;

                            var insert = false;

                            for (var j1 = 0; j1 < entries.length; j1++) {
                                if (entries[j1] != '') {
                                    insert = true;
                                }
                                switch (j1) {
                                    case 0: tmpModel.attributes.Field01 = entries[j1]; break;
                                    case 1: tmpModel.attributes.Field02 = entries[j1]; break;
                                    case 2: tmpModel.attributes.Field03 = entries[j1]; break;
                                    case 3: tmpModel.attributes.Field04 = entries[j1]; break;
                                    case 4: tmpModel.attributes.Field05 = entries[j1]; break;
                                    case 5: tmpModel.attributes.Field06 = entries[j1]; break;
                                    case 6: tmpModel.attributes.Field07 = entries[j1]; break;
                                    case 7: tmpModel.attributes.Field08 = entries[j1]; break;
                                    case 8: tmpModel.attributes.Field09 = entries[j1]; break;
                                    case 9: tmpModel.attributes.Field10 = entries[j1]; break;
                                    case 10: tmpModel.attributes.Field11 = entries[j1]; break;
                                    case 11: tmpModel.attributes.Field12 = entries[j1]; break;
                                }
                            }

                            table_firstVisibleItem++;


                            if (j == (allTextLines.length - 1)) {
                                //app.views.customSchemaDataList.table_addModel(tmpModel, true, jumpFirst, false);
                                var msg = {
                                    tmpModel: tmpModel,
                                    jumpToData: true,
                                    jumpFirst: jumpFirst,
                                    ignoreEmptyContent: false
                                }
                                dialogWaiting.triggerMethod('dialog:close');
                                self.triggerMethod('table_addModel', msg);
                            }
                            else {
                                //app.views.customSchemaDataList.table_addModel(tmpModel, false, jumpFirst, false);
                                var msg = {
                                    tmpModel: tmpModel,
                                    jumpToData: false,
                                    jumpFirst: jumpFirst,
                                    ignoreEmptyContent: false
                                }

                                self.triggerMethod('table_addModel', msg);
                            }
                        }
                    }
                });
                }, 1000);
            };

            this.app.dialogRegion.show(dialogWaiting);

        }
    }
});
